export default __webpack_public_path__ + "static/media/localtext.81feec28.csv";